module.exports = __webpack_public_path__ + "img/shiti.fdf395cf.png";